import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';
import classNames from 'classnames';

import {
  ModalOverlay,
  ResponsiveContent,
  ModalLogoHeader
} from '@evdy/web-core/dist/components/shared/Modal2020';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './MessagePostedModal.module.scss';

import blueHeart from '../../public/images/icons/blue-heart-icon.svg';
import blueLoadingCircle from '../../public/images/icons/blue-loading-circle-icon.svg';

const { resetStaging } = webCommunityOperations;

const {
  'message-posted-modal': messagePostedModalClass,
  'message-posted-body': messagePostedBodyClass,
  'loading-circle': loadingCircleClass,
  loaded: loadedClass
} = styles;

const MessagePostedModal = ({ closeModal, baseRoute }) => {
  const dispatch = useDispatch();
  const [hasLoaded, setHasLoaded] = useState(false);

  // helps handle animation on mount
  useEffect(() => {
    setHasLoaded(true);
    setTimeout(() => {
      browserHistory.push({ pathname: baseRoute });
      dispatch(resetStaging());
    }, 2000);
  }, []);

  const messagePostedBodyClasses = classNames({
    [messagePostedBodyClass]: messagePostedBodyClass,
    [loadedClass]: hasLoaded
  });

  return (
    <ModalOverlay {...{ closeModal }} modalVisible customClass={messagePostedModalClass}>
      <ResponsiveContent>
        <ModalLogoHeader />
        <div className={messagePostedBodyClasses}>
          <img src={blueHeart} alt="blue heart" />
          <p>Thank you, we're posting your message now.</p>
          <img src={blueLoadingCircle} className={loadingCircleClass} alt="loading circle" />
        </div>
      </ResponsiveContent>
    </ModalOverlay>
  );
};

export default MessagePostedModal;
